// A player's finishing position is set by which round eliminated them:
// everyone knocked out in the same round ties for the same place range
// (e.g. every round-1 loser in an 8-player bracket ties for 5th-8th).

export function ordinal(n) {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

export function placementBand(matches, playerId) {
  const eliminationMatch = matches.find(
    (match) =>
      (match.player1Id === playerId || match.player2Id === playerId) &&
      match.status === 'complete' &&
      match.winnerId !== playerId
  );
  if (!eliminationMatch) return null;

  const roundMatches = matches.filter((match) => match.round === eliminationMatch.round);
  const playersBeforeRound = roundMatches.reduce((sum, match) => sum + (match.isBye ? 1 : 2), 0);
  const playersAfterRound = roundMatches.length;

  return { placeStart: playersAfterRound + 1, placeEnd: playersBeforeRound };
}

export function placementLabel(band) {
  if (!band) return null;
  return band.placeStart === band.placeEnd
    ? `${ordinal(band.placeStart)} place`
    : `${ordinal(band.placeStart)}–${ordinal(band.placeEnd)} place`;
}

// Points table: 1st (Champion) 100, 2nd (Runner-up) 60, 3rd-4th (Semifinalist)
// 30, 5th-8th (Quarterfinalist) 15 — the participation baseline is already
// folded into every tier rather than stacked on top. Anything worse than
// 8th (not reachable at the current MAX_PLAYERS=8 cap) falls back to a bare
// participation amount.
export function pointsForPlacement(placement) {
  if (placement === 1) return 100;
  if (placement === 2) return 60;
  if (placement <= 4) return 30;
  if (placement <= 8) return 15;
  return 5;
}

export function tierLabelForPlacement(placement) {
  if (placement === 1) return 'Champion';
  if (placement === 2) return 'Runner-up';
  if (placement <= 4) return 'Semifinalist';
  return 'Quarterfinalist';
}
